/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRenditionImage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m15.929 15.3-1.429 3h5l-1.429-2.25L17 17.175 15.929 15.3zm2.521.2a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z"
        fill="currentcolor"
      />
      <path
        d="M17 2H5v4H2v10h3v4h7v2h10v-9.496L19.404 10H17V2zm-2 8h-3v8H7v-2h3V6H7V4h8v6zM4 8h4v6H4V8zm14.596 4L20 13.354V20h-6v-8h4.596z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRenditionImage as RenditionImage };
